'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/es.symbol.constructor');
require('../modules/es.symbol.for');
require('../modules/es.symbol.key-for');
require('../modules/es.json.stringify');
require('../modules/es.object.get-own-property-symbols');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.symbol.js
// module id = 281
// module chunks = 13